// Central dayjs instance with the plugins the app relies on. Importing dayjs
// from here (rather than directly from 'dayjs') guarantees the plugins are
// registered. dayjs replaces luxon to keep the date library out of the ~70 KB
// gzip entry-chunk weight luxon added.
//
// Plugin map:
//  - utc + timezone  → DateTime.setZone(event.timezone) equivalent (.tz(zone))
//  - relativeTime    → DateTime.toRelative() equivalent (.fromNow())
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

export default dayjs;
export type { Dayjs } from 'dayjs';
